<template>
    <div>
        <div class="hidden-sm hidden-xs">
        <!-- Header Section Begin -->
        <header class="header-section">
            <div class="container">
                <div class="inner-header">
                    <div class="row">
                        <div class="col-lg-3 col-md-3">
                            <div class="logo">
                                <router-link to="/" class="logo">
                                    <img class="logo-cel" src="/images/logo.png" alt="">
                                </router-link>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4">
                        </div>
                        <div class="col-lg-5 col-md-5">
                            <div class="advanced-search hidden-xs">
                                <div class="input-group">
                                    <input type="search" ref="searchInput" v-model="pesquisaChave" @keyup.enter="Pesquisa()" :placeholder="$t('nav.searchPlaceholder')">
                                    <button @click="Pesquisa()"><i class="ti-search"></i></button>
                                </div>
                            </div>
                            <div class="language-bar hidden-xs">
                                <button class="language-button" type="button" @click="languageDialog = true" style="color: #ffffff;">
                                    <i class="fa fa-language"></i>
                                    <span>{{ currentLanguageName }}</span>
                                    <i class="fa fa-angle-down"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="nav-item">
                <div class="container">
                    <div class="nav-depart">
                        <div class="depart-btn">
                            <i class="ti-menu"></i>
                            <span>{{ $t('nav.pacotes') }}</span>
                            <ul class="depart-hover">
                                <li v-for="seg in SegmentosMenu" :key="seg.psgId">
                                    <router-link :to="'/Produtos/' + seg.psgId + '/' + seg.psgNomeSegmento.replaceAll(' ', '-').replaceAll('/', '').replaceAll(',', '')">
                                        {{ $localeField(seg, 'psgNomeSegmento') }}
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <nav class="nav-menu mobile-menu">
                        <ul>
                            <li><router-link to="/">{{ $t('nav.home') }}</router-link></li>
                            <li><router-link to="/sobre">{{ $t('nav.sobre') }}</router-link></li>
                            <li><router-link to="/blog">{{ $t('nav.blog') }}</router-link></li>
                            <!--li><router-link to="/cambio">Câmbio</router-link></!--li-->
                            <li><router-link to="/faleconosco">{{ $t('nav.contato') }}</router-link></li>
                        </ul>
                    </nav>
                    <div id="mobile-menu-wrap"></div>
                </div>
            </div>
        </header>
        <!-- Header End -->        
        </div>
        <div class="language-modal" v-if="languageDialog" @click.self="languageDialog = false">
            <div class="language-modal-content">
                <h3>{{ $t('modal.title') }}</h3>
                <p>{{ $t('modal.selectLanguage') }}</p>
                <div class="language-options">
                    <GoogleTranslator :countries="arrayOfCountries" @on-country-click="languageDialog = false" />
                </div>
                <button type="button" class="language-close" @click="languageDialog = false">{{ $t('modal.close') }}</button>
            </div>
        </div>

        <div class="container hidden-lg hidden-md" style="padding-bottom: 60px;">
            <v-navigation-drawer v-model="drawer" style="margin-top: 64px;">
                <!-- Conteúdo do menu lateral -->
                <v-list>
                    <v-list-item link to="/">
                        <v-list-item-title style="font-size: 16px;">{{ $t('nav.home') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item link to="/sobre">
                        <v-list-item-title style="font-size: 16px;">{{ $t('nav.sobre') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item link to="/blog">
                        <v-list-item-title style="font-size: 16px;">{{ $t('nav.blog') }}</v-list-item-title>
                    </v-list-item>
                    <!--v-list-item link to="/cambio">
                        <v-list-item-title style="font-size: 16px;">Cambio</v-list-item-title>
                    </!--v-list-item-->
                    <v-list-item link @click="drawer3 = !drawer3; drawer = !drawer;">
                        <v-list-item-title class="d-inline" style="font-size: 16px;">{{ $t('nav.pacotes') }}</v-list-item-title>
                        <v-list-item-icon>
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-list-item-icon>
                    </v-list-item>
                    <v-list-item link to="/faleconosco">
                        <v-list-item-title style="font-size: 16px;">{{ $t('nav.contato') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item link @click="drawer2 = !drawer2; drawer = !drawer;">
                        <v-list-item-title class="d-inline" style="font-size: 16px;">{{ $t('nav.generalInfo') }}</v-list-item-title>
                        <v-list-item-icon>
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-list-item-icon>
                    </v-list-item>
                </v-list>
            </v-navigation-drawer>


            <v-navigation-drawer v-model="drawer2" style="margin-top: 64px;">
                <!-- Conteúdo do menu lateral -->
                <v-list>
                    <v-list-item link @click="drawer2 = !drawer2; drawer = !drawer;">
                        <v-list-item-icon>
                            <v-icon class="d-inline">mdi-chevron-left</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title class="d-inline" style="font-size: 13px;">{{ $t('nav.back') }}</v-list-item-title>
                    </v-list-item>
                    <div v-for="itens in informacoes" :key="itens.itiId" class="d-inline">
                        <v-list-item link :to="'/informacoes/' + itens.itiId + '/' + itens.itiNome.replaceAll(' ', '-').replaceAll('/', '').replaceAll(',', '')">
                            <i class="fa fa-check" style="color:#0479bf;"></i>
                            <v-list-item-title style="font-weight: 500; font-size: 15px;padding-left: 8px;color:#333333;display: inline-flex;"> {{ $localeField(itens, 'itiNome') }}</v-list-item-title>
                        </v-list-item>
                    </div>
                </v-list>
            </v-navigation-drawer>

            <v-navigation-drawer v-model="drawer3" style="margin-top: 64px;">
                <!-- Conteúdo do menu lateral -->
                <v-list>
                    <v-list-item link @click="drawer3 = !drawer3; drawer = !drawer;">
                        <v-list-item-icon>
                            <v-icon class="d-inline">mdi-chevron-left</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title class="d-inline" style="font-size: 13px;">{{ $t('nav.back') }}</v-list-item-title>
                    </v-list-item>
                    <div v-for="seg in SegmentosMenu" :key="seg.psgId" class="d-inline">
                        <v-list-item link
                            :to="'/Produtos/' + seg.psgId + '/' + seg.psgNomeSegmento.replaceAll(' ', '-').replaceAll('/', '').replaceAll(',', '')">
                            <i class="fa fa-check" style="color:#0479bf;"></i>
                            <v-list-item-title
                                style="font-weight: 500; font-size: 15px;padding-left: 8px;color:#333333;display: inline-flex;">
                                {{ $localeField(seg, 'psgNomeSegmento') }}</v-list-item-title>
                        </v-list-item>
                    </div>
                </v-list>
            </v-navigation-drawer>

            <!-- Conteúdo principal -->
            <v-app-bar app>
                <v-row align="center" class="logo-cart-container">
                    <v-col class="col" @click.stop="drawer = !drawer" v-if="!showSearch">
                            <img v-if="!drawer" src="/images/MENU.png" alt="Menu Icon" style="width: 80%; height: 80%;" />
                            <img v-else src="/images/FECHAR.png" alt="Close Icon" style="width: 80%; height: 80%;" />
                    </v-col>
                    <v-col class="logo-col" v-if="!showSearch">
                        <img src="/images/logo.png" class="logo-img" style="width: auto;height: 55px;;">
                    </v-col>
                    <v-col v-if="showSearch">
                        <div class="header-search-wrapper" style="padding-left: 5px;">
                            <input type="search" ref="searchInput2" class="form-control" v-model="pesquisaChave" @keyup.enter="Pesquisa()"
                                :placeholder="$t('nav.searchPlaceholder')" required>
                            <a href="#" class="" @click="Pesquisa()">
                                <!--i class="icon-search" style="font-size: 25px;"></!--i-->
                                <img src="/images/LUPA.png" style="height: 35px;">
                            </a>
                            <a href="#" class="" @click="showSearch = !showSearch">
                                <!--i class="icon-close" style="font-size: 25px;"></!--i-->
                                <img src="/images/FECHAR.png" style="height: 40px;">
                            </a>
                        </div>
                    </v-col>    
                    <v-col class="col" v-if="!showSearch" style="padding-right: 20px; display: flex; align-items: center; justify-content: flex-end; gap: 8px;">
                        <div class="dropdown cart-dropdown">
                            <div class="icon"
                                @click="toggleSearch3()">
                                <img src="/images/LUPA.png" style="height: 35px;">
                            </div>
                        </div>
                        <button class="language-button-mobile" type="button" @click="languageDialog = true" aria-label="Selecionar idioma">
                            <i class="fa fa-language"></i>
                            <span>{{ currentLanguageShort }}</span>
                        </button>
                    </v-col>
                </v-row>
            </v-app-bar>
        </div>

    </div>
</template>

<script>
import axios from 'axios';
import GoogleTranslator from '@/components/GoogleTranslator.vue';

export default {
    name: 'PageHeader',
    components: {
        GoogleTranslator,
    },
    data: () => ({
        topo: [],
        redes: [],
        pesquisaChave: '',
        informacoes: [],
        drawer: false,
        drawer2: false,
        drawer3: false,
        showSearch: false,
        showSearch2: false,
        Segmentos: [],
        SegmentosMenu: [],
        linkMenu:[],
        languageDialog: false,
        arrayOfCountries: [
            {
                code: 'pt|pt',
                title: 'Portugues',
                flagIconUrl: '/images/bandeirabrsail.jpg',
            },
            {
                code: 'pt|en',
                title: 'Ingles',
                flagIconUrl: '/images/__English.png',
            },
            {
                code: 'pt|es',
                title: 'Espanhol',
                flagIconUrl: '/images/__Spanish.png',
            },
        ],
    }),
    computed: {
        currentLanguageName() {
            return 'Selecione Idioma';
        },
        currentLanguageShort() {
            return 'IDI';
        },
    },
    methods: {
        toggleSearch2() {
            this.showSearch2 = !this.showSearch2;

            this.$nextTick(() => {
                // Agora, o $refs.searchInput deve estar definido
                this.$refs.searchInput.focus();
            });
        },
        toggleSearch3() {
            this.showSearch = !this.showSearch;

            this.$nextTick(() => {
                // Agora, o $refs.searchInput deve estar definido
                this.$refs.searchInput2.focus();
            });
        },
        Pesquisa() {
            if (this.pesquisaChave == "") {
                this.$mensagemAviso(this.$t('common.searchKeywordRequired'))
            }
            else {
                const novaURL = `/ProdutosPesquisa/${this.pesquisaChave}`;
                this.$router.push(novaURL);
                this.showSearch2 = !this.showSearch2;
                this.showSearch = !this.showSearch;
            }
        }
    },
    watch: {
        languageDialog(value) {
            if (value) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        }
    },
    unmounted() {
        document.body.style.overflow = '';
    },
    async created() {
       
       axios.get('/Process/InsInstitucional/institucional/18/informacoes')
            .then(response => {
                this.informacoes = response.data.filter(x => x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
            })
            .catch(error => {
                console.error(error);
            });

            await axios.get('/Process/ProSegmentos/GetAll')
                .then(response => {
                    this.Segmentos = response.data;
                    this.SegmentosMenu = this.Segmentos
                        .filter(x => x.psgIdPai == 0 && x.psgVisivel)
                        .sort((a, b) => a.psgOrdem - b.psgOrdem); // Ordenação numérica
                })
                .catch(error => {
                    console.error(error);
                });
    }
}
</script>

<style>
    .language-bar {
        margin-top: 10px;
        display: flex;
        justify-content: flex-end;
    }

    .language-button,
    .language-button-mobile {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        border: 1px solid #0479bf;
        color: #ffffff;
        background: #0479bf;
        padding: 9px 14px;
        border-radius: 6px;
        cursor: pointer;
        font-size: 13px;
        font-weight: 700;
        line-height: 1;
        min-width: 154px;
        box-shadow: 0 8px 18px rgba(4, 121, 191, 0.22);
        transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
        text-transform: uppercase;
    }

    .language-button:hover,
    .language-button-mobile:hover {
        border-color: #025f98;
        background: #025f98;
        transform: translateY(-1px);
    }

    .language-button i,
    .language-button-mobile i {
        font-size: 16px;
    }

    .language-modal {
        position: fixed;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px;
        background: rgba(0, 0, 0, 0.65);
        z-index: 99999;
    }

    .language-modal-content {
        width: 100%;
        max-width: 420px;
        background: #ffffff;
        border-radius: 18px;
        padding: 24px;
        box-shadow: 0 24px 64px rgba(0, 0, 0, 0.22);
        text-align: center;
    }

    .language-modal-content h3 {
        margin-bottom: 16px;
        font-size: 22px;
    }

    .language-modal-content p {
        margin-bottom: 20px;
        color: #4a4a4a;
    }

    .language-options {
        display: grid;
        gap: 10px;
        margin-bottom: 20px;
    }

    .language-option {
        padding: 12px 16px;
        border: 1px solid #0479bf;
        color: #0479bf;
        background: transparent;
        border-radius: 10px;
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .language-option:hover {
        background: #0479bf;
        color: #ffffff;
    }

    .language-close {
        padding: 12px 20px;
        background: #0479bf;
        color: #ffffff;
        border: none;
        border-radius: 10px;
        cursor: pointer;
    }

@media (max-width:768px) {
    .logo-col {
        flex: 5;
        /* Ajuste o valor para controlar o tamanho do logo */
    }

    .icon-col {
        flex: 1;
        /* Ajuste o valor para controlar o tamanho dos ícones e o espaço entre eles */
    }

    .logo-img {
        width: 100%;
        /* Para fazer o logo ocupar 100% da largura da coluna */
    }

    .search-container {
        position: absolute;
        background-color: white;
        /* Cor de fundo do campo de pesquisa */
        z-index: 1;
        /* Para sobrepor o conteúdo abaixo */
        width: 100%;
        /* Para ocupar a largura da barra de aplicativos */
        top: 60px;
        /* Ajuste conforme necessário para a posição vertical desejada */
        padding: 5px;
        /* Espaçamento interno do campo de pesquisa */
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        /* Sombra, opcional */
    }

    .search-input {
        width: 100%;
        padding: 10px;
    }

    .header-search-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .language-bar {
        margin-top: 10px;
        display: flex;
        justify-content: flex-end;
    }

    .language-button,
    .language-button-mobile {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        border: 1px solid #0479bf;
        color: #ffffff;
        background: #0479bf;
        padding: 8px 10px;
        border-radius: 6px;
        cursor: pointer;
        font-size: 12px;
        font-weight: 700;
        line-height: 1;
        min-width: 58px;
        box-shadow: 0 6px 14px rgba(4, 121, 191, 0.22);
        text-transform: uppercase;
    }

    .language-button i,
    .language-button-mobile i {
        font-size: 15px;
    }

    .language-modal {
        position: fixed;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px;
        background: rgba(0, 0, 0, 0.65);
        z-index: 99999;
    }

    .language-modal-content {
        width: 100%;
        max-width: 420px;
        background: #ffffff;
        border-radius: 18px;
        padding: 24px;
        box-shadow: 0 24px 64px rgba(0, 0, 0, 0.22);
        text-align: center;
    }

    .language-modal-content h3 {
        margin-bottom: 16px;
        font-size: 22px;
    }

    .language-modal-content p {
        margin-bottom: 20px;
        color: #4a4a4a;
    }

    .language-options {
        display: grid;
        gap: 10px;
        margin-bottom: 20px;
    }

    .language-option {
        padding: 12px 16px;
        border: 1px solid #0479bf;
        color: #0479bf;
        background: transparent;
        border-radius: 10px;
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .language-option:hover {
        background: #0479bf;
        color: #ffffff;
    }

    .language-close {
        padding: 12px 20px;
        background: #0479bf;
        color: #ffffff;
        border: none;
        border-radius: 10px;
        cursor: pointer;
        width: 100%;
    }

    .cart-count {
    position: absolute;
    top: -3px;
    right: -3px;
    background-color: #B91F1C;;
    color: white;
    border-radius: 50%;
    padding-left: 6px;
    padding-right: 6px;
    padding-top: 3px;
    padding-bottom: 2px;
    font-size: 9px;
}
}

    .v-navigation-drawer__scrim {
    position: absolute;
    width: 100%;
    height: 100%;
     background: none !important; 
    opacity: 0.2;
    transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 1;
}

@media (min-width:768px) {
    .v-col {
    flex-basis: 0;
    flex-grow: 0.3 !important;
    max-width: 100%;
}

.logo-col {
        flex: 5;
        /* Ajuste o valor para controlar o tamanho do logo */
    }

    .icon-col {
        flex: 1;
        /* Ajuste o valor para controlar o tamanho dos ícones e o espaço entre eles */
    }

    .logo-img {
        width: 100%;
        /* Para fazer o logo ocupar 100% da largura da coluna */
    }

    .search-container {
        position: absolute;
        background-color: white;
        /* Cor de fundo do campo de pesquisa */
        z-index: 1;
        /* Para sobrepor o conteúdo abaixo */
        width: 100%;
        /* Para ocupar a largura da barra de aplicativos */
        top: 60px;
        /* Ajuste conforme necessário para a posição vertical desejada */
        padding: 5px;
        /* Espaçamento interno do campo de pesquisa */
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        /* Sombra, opcional */
    }

    .search-input {
        width: 100%;
        padding: 10px;
    }

    .header-search-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .cart-count {
    position: absolute;
    top: -3px;
    right: -3px;
    background-color: #B91F1C;;
    color: white;
    border-radius: 50%;
    padding-left: 6px;
    padding-right: 6px;
    padding-top: 3px;
    padding-bottom: 2px;
    font-size: 9px;
}
}

@media screen and (max-width: 575px){
    .cart-dropdown {
    padding-left: 0px !important;
}
}

.custom-div {
  border-bottom: 2px solid #ccc; /* Cor e espessura da borda inferior */
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1); /* Sombra na parte inferior */
}

.cart-link {
  position: relative;
}
@media (min-width:1200px) {
.cart-count {
    position: absolute;
    top: -41px;
    right: -28px;
    background-color: #B91F1C;;
    color: white;
    border-radius: 50%;
    padding-left: 6px;
    padding-right: 6px;
    padding-top: 3px;
    padding-bottom: 2px;
    font-size: 9px;
}
}

.custom-row {
  display: flex;
}

.custom-col {
  flex: 1;
  margin-right: 10px; /* Ajuste conforme necessário para o espaçamento entre as colunas */
}

.main-nav {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .menu-item {
    position: relative;
    padding: 5px 10px;
    display: inline-block;
  }

  .submenu {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    z-index: 1;
  }

  .menu-item:hover .submenu {
    display: block;
  }

</style>
